module.exports = __webpack_public_path__ + "img/logo.e748ee59.png";